import { render } from "./IconTwitter.vue?vue&type=template&id=d04fcbf0"
import script from "./IconTwitter.vue?vue&type=script&lang=js"
export * from "./IconTwitter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__